import { render, staticRenderFns } from "./CustomerQADetail.vue?vue&type=template&id=cf5ca0fe&"
import script from "./CustomerQADetail.vue?vue&type=script&lang=js&"
export * from "./CustomerQADetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQADetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports